import Vue from 'vue'
import store from './store'
import App from './App.vue'

Vue.config.productionTip = false

Vue.filter('toCurrency', function (value) {
  if (isNaN(parseFloat(value))) {
    return value;
  }
  var formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });
  return formatter.format(parseFloat(value));
});

new Vue({
  render: h => h(App),
  store,
}).$mount('#wp-vue-app')



// WEBPACK FOOTER //
// ./src/main.js